import React from 'react';
import Modal from 'react-bootstrap/Modal';

const Alert = ({ show, onHide, title, message, onSubmit }) => (
    <Modal
        show={show}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
                {title}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>
                {message}
            </p>
        </Modal.Body>
        <Modal.Footer>
            <button className="btn btn-primary" onClick={onHide}>Close</button>
            {onSubmit ? (<button className="btn btn-primary" onClick={onSubmit}>Submit</button>) : null}
        </Modal.Footer>
    </Modal>
);

export default Alert;